import Svg, { SvgProps, Path } from 'react-native-svg';

const LogOutIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M15 3c-2.555 0-4.917.819-6.854 2.182a1 1 0 1 0 1.15 1.636A9.852 9.852 0 0 1 15 5c5.535 0 10 4.465 10 10s-4.465 10-10 10a9.852 9.852 0 0 1-5.703-1.818 1 1 0 0 0-1.15 1.636A11.876 11.876 0 0 0 15 27c6.615 0 12-5.385 12-12S21.615 3 15 3zM6.98 9.99a1 1 0 0 0-.687.303l-3.912 3.912a1 1 0 0 0 .002 1.592l3.91 3.91a1 1 0 1 0 1.414-1.414L5.414 16H16a1 1 0 1 0 0-2H5.414l2.293-2.293A1 1 0 0 0 6.98 9.99z" />
  </Svg>
);

export default LogOutIcon;
